export default __webpack_public_path__ + "static/Resume-86271263c5944bec6cf5b94e37b1a17a.pdf";